<template>
  <div>
    <div class="plantroom landscape">
      <transition name="fade">
        <div class="tocorridor" v-show="tocorridor"></div>
      </transition>
      <transition name="fade">
        <div class="onTomatoes" v-show="onTomatoes"></div>
      </transition>
      <transition name="fade">
        <div class="onDoor" v-show="onDoor"></div>
      </transition>
      <transition name="fade">
        <div class="onAsparagus" v-show="onAsparagus"></div>
      </transition>
      <router-link to="/corridor-chill">
        <div
          class="corridor"
          :class="{ cursorLeft: tocorridor }"
          @mouseover="
            tocorridor = true;
            $store.commit('setToPlace', 'back_to_corridor');
          "
          @mouseleave="
            tocorridor = false;
            $store.commit('setToPlace', '...');
          "
        ></div>
      </router-link>
      <div
        class="tomatoes"
        @mouseover="
          onTomatoes = true;
          $store.commit('setToPlace', 'check_space_tomatoes');
        "
        @mouseleave="
          onTomatoes = false;
          $store.commit('setToPlace', '...');
        "
        @click="toggleEntry(1)"
      ></div>
      <router-link to="/next-release">
        <div
          class="door"
          @mouseover="
            onDoor = true;
            $store.commit('setToPlace', 'mysterious_door');
          "
          @mouseleave="
            onDoor = false;
            $store.commit('setToPlace', '...');
          "
        ></div>
      </router-link>

      <div
        class="asparagus"
        @mouseover="
          onAsparagus = true;
          $store.commit('setToPlace', 'check_space_asparagus');
        "
        @mouseleave="
          onAsparagus = false;
          $store.commit('setToPlace', '...');
        "
        @click="toggleEntry(2)"
      ></div>

      <PlantroomEntry
        @closePopup="toggleEntry(0)"
        :entry="infos.tomatoes"
        v-if="showEntry == 1"
      ></PlantroomEntry>
      <PlantroomEntry
        @closePopup="toggleEntry(0)"
        :entry="infos.asparagus"
        v-if="showEntry == 2"
      ></PlantroomEntry>
      <Portal></Portal>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
import Portal from "./Portal";
import NotOriented from "@/components/mobile/NotOriented";
import MainMixin from "@/components/utilities/MainMixin";
import PlantroomEntry from "@/components/utilities/PlantroomEntry";
import plantroomInfos from "@/components/utilities/plantroom-infos";
export default {
  name: "Plantroom",
  title: "Les bons plants",
  mixins: [MainMixin],
  components: {
    Portal,
    NotOriented,
    PlantroomEntry,
  },
  mounted() {
    this.init();
    let newMsg = {
      text:
        '"Les Bons Plants" room was designed to thank all the cool humans who helped us get this DIY ship in orbit. Call on them for your needs they\'re the best in their fields.',
      delay: 7000,
    };
    window.addEventListener("keyup", (e) => this.eventClose(e));
    this.$store.commit("setWanerMsg", newMsg);
  },
  destroyed() {
    window.removeEventListener("keyup", (e) => this.eventClose(e));
  },
  data() {
    return {
      infos: plantroomInfos,
      tocorridor: false,
      onTomatoes: false,
      onDoor: false,
      onAsparagus: false,
      showEntry: 0,
    };
  },
  methods: {
    toggleEntry(id) {
      this.$store.commit("focusOnStuff");
      this.showEntry = id;
    },
    eventClose(e) {
      if (e.key === "Escape") {
        if (this.showEntry !== 0) this.toggleEntry(0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.plantroom {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/plantroom.jpg");
  background-size: 100vw 100vh;
  background-color: black;
}

.corridor {
  position: absolute;
  bottom: 0;
  height: 25vh;
  width: 50vw;
  left: 20vw;
}

.tocorridor {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/planttocorridor.jpg");
  background-size: 100vw 100vh;
}

.tomatoes {
  position: absolute;
  bottom: 17vh;
  height: 50vh;
  width: 20vw;
  right: 8vw;
}

.onTomatoes {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/plantroom-tomatoes.jpg");
  background-size: 100vw 100vh;
}

.door {
  position: absolute;
  bottom: 35vh;
  height: 25vh;
  width: 12vw;
  right: 27vw;
}

.onDoor {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/plantroom-door.jpg");
  background-size: 100vw 100vh;
}
.asparagus {
  position: absolute;
  bottom: 30vh;
  height: 25vh;
  width: 18vw;
  left: 35vw;
}

.onAsparagus {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/plantroom-asparagus.jpg");
  background-size: 100vw 100vh;
}
</style>
